function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8301 5.73633C15.8301 5.73633 16.5 5.73633 19 5.73633C21.5 5.73633 24.5 5.872 24.5 8.73633C24.5 11.6007 21.5 11.7363 19.16 11.7363C16.82 11.7363 15.919 11.7363 12.33 11.7363C7.83002 11.7363 4.5 14.1377 4.5 18.2364C4.5 22.835 8.55837 24.2216 12.33 24.2363C15.83 24.2499 21.5672 24.2363 21.5672 24.2363M27.4501 21.9563C27.4501 25.3063 24.2201 26.7363 24.2201 26.7363C22.332 25.7283 21.0092 24.1148 20.9901 21.9563C20.9814 20.9718 21.3304 20.2781 21.9361 19.6723C22.5419 19.0666 23.3634 18.7263 24.2201 18.7263C25.0767 18.7263 25.8983 19.0666 26.504 19.6723C27.1098 20.2781 27.4501 21.0996 27.4501 21.9563Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.d7d927c5.svg";
export { ForwardRef as ReactComponent };